// @ts-nocheck
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import * as React from "react"

import { cn } from "@/utils"

// Create a wrapper component that provides the tooltip context
const TooltipProvider = TooltipPrimitive.Provider

// Root component that manages the open state
const Tooltip = ({ delayDuration = 200, ...props }: { delayDuration?: number } & React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Root>) => (
  <TooltipPrimitive.Root delayDuration={delayDuration} {...props} />
)

// The element that triggers the tooltip
const TooltipTrigger = TooltipPrimitive.Trigger

// Portal to render the tooltip outside the DOM hierarchy
const TooltipPortal = TooltipPrimitive.Portal

// The actual tooltip content - uses Portal to escape stacking context issues
const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-[9999] overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md transition-opacity duration-150 data-[state=open]:opacity-100 data-[state=closed]:opacity-0",
        className
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

// Arrow component for the tooltip
const TooltipArrow = TooltipPrimitive.Arrow

export {
  Tooltip, TooltipArrow, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger
}

